import { Box, type BoxProps } from "@chakra-ui/react"

interface HtmlContentProps extends Omit<BoxProps, "content"> {
  content: string | null | undefined
}

const richTextContentStyles = {
  "& p": { margin: "0.5em 0" },
  "& p:first-of-type": { marginTop: 0 },
  "& p:last-child": { marginBottom: 0 },
  "& ul, & ol": { paddingLeft: "1.5em", margin: "0.5em 0" },
  "& ul": { listStyleType: "disc" },
  "& ol": { listStyleType: "decimal" },
  "& li": { display: "list-item" },
  "& li p": { margin: 0 },
  "& h2": { fontSize: "1.5em", fontWeight: "bold", margin: "0.75em 0" },
  "& h3": { fontSize: "1.25em", fontWeight: "bold", margin: "0.75em 0" },
  "& h1": { fontSize: "2em", fontWeight: "bold", margin: "0.75em 0" },
  "& h4": { fontSize: "1.125em", fontWeight: "bold", margin: "0.75em 0" },
  "& h5": { fontSize: "1em", fontWeight: "bold", margin: "0.75em 0" },
  "& h6": { fontSize: "0.875em", fontWeight: "bold", margin: "0.75em 0" },
  "& strong": { fontWeight: "bold" },
  "& em": { fontStyle: "italic" },
  "& s": { textDecoration: "line-through" },
  "& blockquote": {
    borderLeftWidth: "4px",
    borderLeftStyle: "solid",
    borderLeftColor: "border",
    paddingLeft: "1em",
    margin: "0.75em 0",
    color: "fg.muted",
  },
  "& code": {
    fontFamily: "mono",
    fontSize: "0.875em",
    background: "bg.muted",
    padding: "0.125em 0.25em",
    borderRadius: "sm",
  },
  "& pre": {
    overflowX: "auto",
    background: "bg.muted",
    padding: "0.75em 1em",
    margin: "0.75em 0",
    borderRadius: "sm",
  },
  "& pre code": { background: "transparent", padding: 0 },
  "& hr": { borderTopWidth: "1px", borderColor: "border", margin: "1em 0" },
  "& a": { color: "fg.info", textDecoration: "underline" },
  "& img": {
    display: "block",
    maxWidth: "100%",
    height: "auto",
    margin: "1em auto",
  },
  "& table": { width: "100%", margin: "1em 0", borderCollapse: "collapse" },
  "& th, & td": {
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "border",
    padding: "0.5em 0.75em",
    textAlign: "left",
    verticalAlign: "top",
  },
  "& th": { fontWeight: "bold" },
} satisfies NonNullable<BoxProps["css"]>

export function HtmlContent({ content, css, ...props }: HtmlContentProps) {
  if (!content) return null

  return (
    <Box
      dangerouslySetInnerHTML={{ __html: content }}
      css={{ ...richTextContentStyles, ...css }}
      {...props}
    />
  )
}
